var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "new-tab",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.92,7.08c-.05-.12-.12-.23-.22-.33s-.21-.17-.33-.22c-.12-.05-.24-.07-.38-.08h-6c-.55,0-1,.45-1,1s.45,1,1,1h3.59l-7.29,7.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l7.29-7.29v3.59c0,.55.45,1,1,1s1-.45,1-1v-6h0c0-.14-.03-.26-.08-.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25,16.46c-.55,0-1,.45-1,1v6c0,.55-.45,1-1,1h-14c-.55,0-1-.45-1-1v-14c0-.55.45-1,1-1h6c.55,0,1-.45,1-1s-.45-1-1-1h-6c-1.65,0-3,1.35-3,3v14c0,1.65,1.35,3,3,3h14c1.65,0,3-1.35,3-3v-6c0-.55-.45-1-1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/newTab.3a5262aebca602897339d3d747b337c3.svg";
export { ForwardRef as ReactComponent };